import { useChatStore } from '@widgets/messenger/stores/useChatStore'
import messengerApiService from '@widgets/messenger/services/messengerApiService'
import { useWidgetAttachments, type UploadApiCallback } from '@widgets/messenger/compositions/useWidgetAttachments'
import { useChatEditorAttachmentStore } from '@widgets/messenger/stores/useChatEditorAttachmentStore'

export const useWidgetChatEditorAttachments = () => {
  const chatStore = useChatStore()
  const attachmentStore = useChatEditorAttachmentStore()
  const widgetAttachments = useWidgetAttachments(attachmentStore, 'chat')

  const uploadApiCallback: UploadApiCallback = ({ file, id }) => {
    return messengerApiService.uploadChatAttachment(
      chatStore.chatToken.value,
      {
        file,
      },
      (event) => {
        widgetAttachments.updateProgress(id, event.loaded)
      },
    )
  }

  const uploadAttachments = (files: File[]) => {
    return widgetAttachments.uploadAttachments({
      files,
      uploadApiCallback,
    })
  }

  const retryAttachment = (id: string) => {
    return widgetAttachments.retryAttachment({ id, uploadApiCallback })
  }

  return {
    attachments: widgetAttachments.attachments,
    uploadAttachments,
    retryAttachment,
    removeAttachment: widgetAttachments.removeAttachment,
    setAttachments: widgetAttachments.setAttachments,
    clearAttachments: widgetAttachments.clearAttachments,
    getUploadedAttachments: widgetAttachments.getUploadedAttachments,
  }
}
